
<div class="property_page" *ngIf="room">

  <!-- IMAGES & MISE EN FAVORIS -->
  <app-accommodation-photo [room]="room" [urlPrefix]="urlPrefix" [selectedCity]="selectedCity" [currentId]="currentId" [propertyPhotos]="propertyPhotos"></app-accommodation-photo>
  <div [ngClass]="{'container-fluid': isMobile, 'margin-page': isMobile}">

    <app-accommodation-features [amenities_1]="amenities_1" [amenities_2]="amenities_2" [type]="'features'" [room]="room" page="property"
      *ngIf="(amenities_1 && amenities_1.length > 0) || (amenities_2 && amenities_2.length > 0)">
    </app-accommodation-features>

    <app-accommodation-features [type]="'charges'" [room]="room"></app-accommodation-features>

    <div class="pt-4 mb-0">
      <h3>
        <span class="subtitle_1 txt-darkGray pb-2">{{ 'PROCESSES.ACCOMMODATION.LIST.PROPERTY_DESCRIPTION' | translate }}</span>
      </h3>
      <p id="resume" class="mt-3 text_1" [ngClass]="{'line-clamp': !showDesc}" *ngIf="room.property_description.summary_fr || room.property_description.summary"
        [innerHTML]="locale === 'fr' && room.property_description.summary_fr ? room.property_description.summary_fr : room.property_description.summary"></p>

      <button class="btn border-0 btn-link p-0 mediumGray mt-2" (click)="manageDesc()" *ngIf="showMoreBtn">
        {{ 'COMMON.SHOW.' + (showDesc ? 'LESS' : 'MORE') | translate }}
      </button>

    </div>

     <app-accommodation-map [room]="room">
     </app-accommodation-map>

  </div>
  <app-accommodation-price-box *ngIf="!userOngoingBookings" [room]="room"></app-accommodation-price-box>

  <div [ngClass]="{'container-fluid': isMobile, 'margin-page': isMobile}">
    <app-accomodation-owner [room]="room"></app-accomodation-owner>


    <app-accommodation-item-card [otherRooms]="otherRooms" *ngIf="otherRooms && otherRooms.length > 0" [favList]="favList"
      [type]="'otherRooms'" [name]="'otherRoomsCard'"></app-accommodation-item-card>

    <app-accommodation-reservation-process></app-accommodation-reservation-process>

    <app-faq-accordion [faqFields]="FaqItems" *ngIf="FaqItems && FaqItems.length > 0"></app-faq-accordion>


  </div>

  <!-- TOO MANY FAV MODAL -->
  <app-component-modal-favorite [favList]="favList" *ngIf="showFavErrorModal"
    (isModalClosed)="showFavErrorModal = $event"></app-component-modal-favorite>
</div>
